<img
  [src]="this.bannerUrl"
  [ngClass]="[this.bannerClass, this.clickable ? 'clickable' : '']"
  (click)="bannerClicked()"
/>
